webpackJsonp([1],{

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loan: {
    statusOptions: [{
      label: '待管理员审核',
      value: 1
    }, {
      label: '待领导审核',
      value: 2
    }, {
      label: '待约定时间取设备',
      value: 3
    }, {
      label: '使用中',
      value: 4
    }, {
      label: '超期未归还',
      value: 5
    }, {
      label: '续期申请待审核',
      value: 6
    }, {
      label: '续期使用中',
      value: 7
    }, {
      label: '已归还',
      value: 8
    }, {
      label: '已取消',
      value: 9
    }]
  },
  device: {
    statusOptions: [{
      label: '正常',
      value: 1
    }, {
      label: '待修',
      value: 2
    }, {
      label: '维修中',
      value: 3
    }, {
      label: '报废',
      value: 4
    }, {
      label: '闲置',
      value: 5
    }]
  }
});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nprogress__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nprogress_nprogress_css__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_store__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mock_index__ = __webpack_require__(197);











if (false) {
  mock();
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_5_nprogress___default.a.configure({ showSpinner: false });

__WEBPACK_IMPORTED_MODULE_7__routes__["a" /* default */].beforeEach(function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].state.user.isLogin) {
    next();
  } else {
    if (to.name === 'login') {
      next();
    } else {
      next({ name: 'login' });
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  router: __WEBPACK_IMPORTED_MODULE_7__routes__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
}).$mount('#app'));

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_INITIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXIT_LOGIN; });

var GET_INITIAL = 'GET_INITIAL';

var LOGIN_IN = 'LOGIN_IN';
var EXIT_LOGIN = 'EXIT_LOGIN';

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mockjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getInitialInfo__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getUserListPage__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getGroupListPage__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getCreditListPage__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getDeviceListPage__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getLoanListPage__ = __webpack_require__(262);









/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock('/ajaxhandler.ashx', function (req) {
    if (req.type === 'POST') {
      var body = JSON.parse(req.body);

      if (body.mode === 'login') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__login__["a" /* default */])(body.data);
      } else if (body.mode === 'getInitialInfo') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getInitialInfo__["a" /* default */])();
      } else if (body.mode === 'getUserListPage') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__getUserListPage__["a" /* default */])(body.data);
      } else if (body.mode === 'getGroupListPage') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getGroupListPage__["a" /* default */])(body.data);
      } else if (body.mode === 'getCreditListPage') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getCreditListPage__["a" /* default */])(body.data);
      } else if (body.mode === 'getDeviceListPage') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getDeviceListPage__["a" /* default */])(body.data);
      } else if (body.mode === 'getLoanListPage') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getLoanListPage__["a" /* default */])(body.data);
      } else {
        return { error_code: 0, msg: '该接口没有mock', data: {} };
      }
    }
  });
});;

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login_vue__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home_vue__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Main_vue__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_404_vue__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_user_user__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_user_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_user_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_user_group__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_user_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_user_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_loan_loan__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_loan_loan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_loan_loan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_device_device__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_device_device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_device_device__);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Login_vue___default.a,
  name: 'login',
  hidden: true
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_Home_vue___default.a,
  name: '用户',
  iconCls: 'iconfont icon-user',
  children: [{ path: '/main', component: __WEBPACK_IMPORTED_MODULE_4__pages_Main_vue___default.a, name: '主页', hidden: true }, { path: '/user', component: __WEBPACK_IMPORTED_MODULE_6__pages_user_user___default.a, name: '用户管理' }, { path: '/group', component: __WEBPACK_IMPORTED_MODULE_7__pages_user_group___default.a, name: '用户组别' }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_Home_vue___default.a,
  name: '借用',
  iconCls: 'iconfont icon-chakanjieyongjilu',
  children: [{ path: '/loan', component: __WEBPACK_IMPORTED_MODULE_8__pages_loan_loan___default.a, name: '借用记录' }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_Home_vue___default.a,
  name: '设备',
  iconCls: 'iconfont icon-shebei',
  children: [{ path: '/device', component: __WEBPACK_IMPORTED_MODULE_9__pages_device_device___default.a, name: '设备管理' }]
}, {
  path: '*',
  name: '404',
  component: __WEBPACK_IMPORTED_MODULE_5__pages_404_vue___default.a,
  hidden: true
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
}));

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_base__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(270);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    base: __WEBPACK_IMPORTED_MODULE_2__modules_base__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */]
  }
}));

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {}
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			sysUserName: ''
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(a, b) {},

		logout: function logout() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {}).then(function () {
				_this.$store.dispatch('signOut');
				_this.$router.push('/login');
			}).catch(function () {});
		}
	},
	mounted: function mounted() {
		var user = this.$store.state.user.userData;
		if (user) {
			this.sysUserName = user.username || '';
		}

		this.$store.dispatch('getInitialInfo');
	}
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: 'admin',
        checkPass: '123456'
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },

  methods: {
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;
          __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.start();
          var loginParams = { username: _this2.ruleForm2.account, password: _this2.ruleForm2.checkPass };
          _this2.$store.dispatch('login', {
            data: loginParams
          }).then(function (res) {
            _this2.logining = false;
            __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
            if (res.error_code === 0) {
              _this2.logining = false;
              _this2.$router.push({ name: '用户管理' });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_util__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_conf__ = __webpack_require__(142);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filters: {
        id: '',
        deviceName: '',
        status: '',
        administrator: ''
      },
      devices: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      editFormVisible: false,
      editFormTtile: '编辑',
      editForm: {
        id: 0,
        deviceName: '',
        administrator: '',
        location: '',
        price: '',
        status: ''
      },
      editFormRules: {
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        administrator: [{ required: true, type: 'number', message: '请选择设备管理员', trigger: 'change' }],
        location: [{ required: true, message: '请输入存放地点', trigger: 'blur' }],
        price: [{ required: true, type: 'number', message: '请输入价格', trigger: 'blur' }],
        status: [{ required: true, type: 'number', message: '请选择状态', trigger: 'change' }]
      },
      editLoading: false,
      btnEditText: '提 交',
      statusOptions: __WEBPACK_IMPORTED_MODULE_4__assets_js_conf__["a" /* default */].device.statusOptions
    };
  },

  computed: {
    deviceAdministrators: function deviceAdministrators() {
      return this.$store.state.base.deviceAdministrators;
    },
    formattedDevices: function formattedDevices() {
      var _this2 = this;

      var formattedDevices = [];

      formattedDevices = this.devices.map(function (item, index) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.deviceAdministrators), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var administrator = _step.value;

            if (administrator.uid === item.administrator) {
              item.formattedAdministrator = administrator.name;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.statusOptions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var status = _step2.value;

            if (status.value === item.status) {
              item.formattedStatus = status.label;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return item;
      });

      return formattedDevices;
    }
  },
  methods: {
    getPageDevices: function getPageDevices(val) {
      this.page = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var checkedFilters = {};

      for (var item in this.filters) {
        if (this.filters.hasOwnProperty(item) && !!this.filters[item].toString()) {
          checkedFilters[item] = this.filters[item];
        }
      }

      var para = {
        page: this.page,
        pageSize: this.pageSize,
        filters: checkedFilters
      };

      this.listLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].getDeviceListPage(para).then(function (res) {
        _this3.total = res.data.total;
        _this3.devices = res.data.devices;
        _this3.listLoading = false;
      }).catch(function () {});
    },

    handleDel: function handleDel(row) {
      var _this = this;
      this.$confirm('确认删除该设备吗?', '提示', {
        type: 'warning'
      }).then(function () {
        _this.listLoading = true;
        var para = {
          id: row.id
        };

        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].delDevice(para).then(function (res) {
          _this.listLoading = false;
          if (res.error_code === 0) {
            _this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            _this.getDevices();
          }
        }).catch(function () {
          console.log('error');
        });
      }).catch(function () {});
    },

    handleAdd: function handleAdd() {
      this.editFormVisible = true;
      this.editFormTtile = '新增';
      this.editForm.id = 0;
      this.editForm.deviceName = '';
      this.editForm.administrator = '';
      this.editForm.location = '';
      this.editForm.price = '';
      this.editForm.status = '';
    },

    handleEdit: function handleEdit(row) {
      this.editFormVisible = true;
      this.editFormTtile = '编辑';
      this.editForm.id = row.id;
      this.editForm.deviceName = row.deviceName;
      this.editForm.administrator = row.administrator;
      this.editForm.location = row.location;
      this.editForm.price = row.price;
      this.editForm.status = row.status;
    },

    editSubmit: function editSubmit() {
      var _this = this;

      _this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this.editLoading = true;
            _this.btnEditText = '提交中';

            __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].updateDevice(_this.editForm).then(function (res) {
              if (res.error_code === 0) {
                _this.$notify({
                  title: '成功',
                  message: '提交成功',
                  type: 'success'
                });
                _this.editLoading = false;
                _this.btnEditText = '提 交';
                _this.resetForm('editForm');
                _this.editFormVisible = false;
                _this.getDevices();
              }
            });
          }).catch(function () {});
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted: function mounted() {
    this.getPageDevices(1);
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_conf__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_util__ = __webpack_require__(71);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filters: {
        loanId: '',
        loaner: '',
        phone: '',
        group: '',
        status: []
      },
      loanList: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      statusOptions: __WEBPACK_IMPORTED_MODULE_3__assets_js_conf__["a" /* default */].loan.statusOptions,
      addCreditVisible: false,
      addCreditForm: {
        id: 0,
        type: '',
        score: '',
        message: '',
        loanId: '' },
      addCreditFormRules: {
        type: [{ required: true, type: 'number', message: '请选择加分/减分', trigger: 'change' }],
        score: [{ required: true, type: 'number', message: '请填写分数', trigger: 'blur' }],
        loanId: [{ required: true, type: 'number', message: '请填写借用编号', trigger: 'blur' }]
      },
      addCreditLoading: false,
      btnAddCreditText: '提 交'
    };
  },

  computed: {
    groupOptions: function groupOptions() {
      return this.$store.state.base.groupOptions;
    },
    formattedLoanList: function formattedLoanList() {
      var _this2 = this;

      return this.loanList.map(function (item, index) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.statusOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var status = _step.value;

            if (status.value === item.status) {
              item.formattedStatus = status.label;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        item.formattedLoanTime = __WEBPACK_IMPORTED_MODULE_4__assets_js_util__["a" /* default */].formatDate.format(new Date(item.loanTime));
        item.formattedReturnTime = __WEBPACK_IMPORTED_MODULE_4__assets_js_util__["a" /* default */].formatDate.format(new Date(item.returnTime));

        if (item.status === 8) {
          item.formattedRealReturnTime = __WEBPACK_IMPORTED_MODULE_4__assets_js_util__["a" /* default */].formatDate.format(new Date(item.realReturnTime));
        } else if (item.status <= 3) {
          item.formattedRealReturnTime = '未取用设备';
        } else if (item.status >= 3 && item.status <= 7) {
          item.formattedRealReturnTime = '未归还设备';
        } else if (item.status === 9) {
          item.formattedRealReturnTime = '借用已取消';
        }

        return item;
      });
    }
  },
  methods: {
    getPageLoans: function getPageLoans(val) {
      this.page = val;
      this.getLoans();
    },
    getLoans: function getLoans() {
      var _this3 = this;

      var checkedFilters = {};

      for (var item in this.filters) {
        if (this.filters.hasOwnProperty(item) && !!this.filters[item].toString()) {
          checkedFilters[item] = this.filters[item];
        }
      }

      var para = {
        page: this.page,
        pageSize: this.pageSize,
        filters: checkedFilters
      };

      console.log(1111);
      console.log(para);

      this.listLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].getLoanListPage(para).then(function (res) {
        console.log(2222);
        console.log(res.data);
        _this3.total = res.data.total;
        _this3.loanList = res.data.loanList;
        _this3.listLoading = false;
      }).catch(function () {});
    },
    handleAdminExamine: function handleAdminExamine(loanItem, isPass) {
      var _this4 = this;

      var para = {
        isPass: isPass,
        id: loanItem.loanId
      };

      if (isPass) {
        this.$confirm('确认通过吗?', '提示', {
          type: 'success'
        }).then(function () {
          _this4.listLoading = true;

          __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].handleAdminExamine(para).then(function (res) {
            _this4.listLoading = false;
            if (res.error_code === 0) {
              _this4.$notify({
                title: '成功',
                message: '审核通过',
                type: 'success'
              });
              _this4.getLoans();
            }
          }).catch(function () {
            console.log('error');
          });
        }).catch(function () {});
      } else {
        this.$prompt('\u4E0D\u901A\u8FC7\u201C' + loanItem.loaner + '\u201D\u501F\u7528\u7533\u8BF7\u7684\u539F\u56E0\uFF08\u975E\u5FC5\u586B\uFF09', '提示', {
          confirmButtonText: '不通过',
          cancelButtonText: '取消'
        }).then(function (_ref) {
          var value = _ref.value;

          if (value) {
            para.message = value;
          }

          __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].handleAdminExamine(para).then(function (res) {
            _this4.listLoading = false;
            if (res.error_code === 0) {
              _this4.$notify({
                title: '成功',
                message: '审核不通过',
                type: 'success'
              });
              _this4.getLoans();
            }
          }).catch(function () {
            console.log('error');
          });
        }).catch(function () {});
      }
    },
    handleLeaderExamine: function handleLeaderExamine(loanItem, isPass) {
      var _this5 = this;

      var para = {
        isPass: isPass,
        id: loanItem.loanId
      };

      if (isPass) {
        this.$confirm('确认通过吗?', '提示', {
          type: 'success'
        }).then(function () {
          _this5.listLoading = true;

          __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].handleLeaderExamine(para).then(function (res) {
            _this5.listLoading = false;
            if (res.error_code === 0) {
              _this5.$notify({
                title: '成功',
                message: '审核通过',
                type: 'success'
              });
              _this5.getLoans();
            }
          }).catch(function () {
            console.log('error');
          });
        }).catch(function () {});
      } else {
        this.$prompt('\u4E0D\u901A\u8FC7\u201C' + loanItem.loaner + '\u201D\u501F\u7528\u7533\u8BF7\u7684\u539F\u56E0\uFF08\u975E\u5FC5\u586B\uFF09', '提示', {
          confirmButtonText: '不通过',
          cancelButtonText: '取消'
        }).then(function (_ref2) {
          var value = _ref2.value;

          if (value) {
            para.message = value;
          }

          __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].handleLeaderExamine(para).then(function (res) {
            _this5.listLoading = false;
            if (res.error_code === 0) {
              _this5.$notify({
                title: '成功',
                message: '审核不通过',
                type: 'success'
              });
              _this5.getLoans();
            }
          }).catch(function () {
            console.log('error');
          });
        }).catch(function () {});
      }
    },

    showCreditBox: function showCreditBox(row) {
      this.addCreditVisible = true;
      this.addCreditForm.id = row.id;
      this.addCreditForm.type = '';
      this.addCreditForm.score = 1;
      this.addCreditForm.message = '';
      this.addCreditForm.loanId = row.loanId;
    },
    addCreditSubmit: function addCreditSubmit() {
      var _this6 = this;

      var _this = this;
      _this.$refs.addCreditForm.validate(function (valid) {
        if (valid) {
          _this6.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this.addCreditLoading = true;
            _this.btnAddCreditText = '提交中';

            __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].addCredit(_this.addCreditForm).then(function (res) {
              if (res.error_code === 0) {
                _this.$notify({
                  title: '成功',
                  message: '添加成功',
                  type: 'success'
                });
                _this.addCreditLoading = false;
                _this.btnAddCreditText = '提 交';
                _this.resetForm('addCreditForm');
                _this.addCreditVisible = false;
                _this.getLoans();
              }
            });
          }).catch(function () {});
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted: function mounted() {
    this.getPageLoans(1);
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_util__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(51);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filters: {
        groupName: '',
        teacher: ''
      },
      groups: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      editFormVisible: false,
      editFormTtile: '编辑',
      editForm: {
        id: 0,
        groupName: '',
        teacher: '',
        linkman: '',
        phone: ''
      },
      editFormRules: {
        groupName: [{ required: true, message: '请输入团队名', trigger: 'blur' }],
        teacher: [{ required: true, message: '请输入导师姓名', trigger: 'blur' }],
        linkman: [{ required: true, message: '请输入团队联系人姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系人联系方式', trigger: 'blur' }]
      },
      editLoading: false,
      btnEditText: '提 交',
      addCreditVisible: false,
      addCreditForm: {
        groupId: 0,
        type: '',
        score: '',
        message: '',
        loanId: '' },
      addCreditFormRules: {
        type: [{ required: true, type: 'number', message: '请选择加分/减分', trigger: 'change' }],
        score: [{ required: true, type: 'number', message: '请填写分数', trigger: 'blur' }]
      },
      addCreditLoading: false,
      btnAddCreditText: '提 交',
      creditListVisible: false,
      creditList: [],
      creditListGroupId: '',
      creditListTotal: 0,
      creditListPage: 1,
      creditListPageSize: 5,
      creditListLoading: false
    };
  },

  computed: {
    formattedCreditList: function formattedCreditList() {
      var formattedCreditList = [];
      var creditMapArr = [{
        label: '加分',
        value: 1
      }, {
        label: '减分',
        value: 2
      }];

      formattedCreditList = this.creditList.map(function (item, index) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(creditMapArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var type = _step.value;

            if (type.value === item.type) {
              item.formattedType = type.label;

              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return item;
      });

      return formattedCreditList;
    }
  },
  methods: {
    getPageGroups: function getPageGroups(val) {
      this.page = val;
      this.getGroups();
    },
    getGroups: function getGroups() {
      var _this2 = this;

      var checkedFilters = {};

      for (var item in this.filters) {
        if (this.filters.hasOwnProperty(item) && !!this.filters[item].toString()) {
          checkedFilters[item] = this.filters[item];
        }
      }

      var para = {
        page: this.page,
        pageSize: this.pageSize,
        filters: checkedFilters
      };

      this.listLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].getGroupListPage(para).then(function (res) {
        _this2.total = res.data.total;
        _this2.groups = res.data.groups;
        _this2.listLoading = false;
      }).catch(function () {});
    },

    handleDel: function handleDel(row) {
      var _this = this;
      this.$confirm('确认删除该组别吗?', '提示', {
        type: 'warning'
      }).then(function () {
        _this.listLoading = true;
        var para = {
          id: row.id
        };

        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].delGroup(para).then(function (res) {
          _this.listLoading = false;
          if (res.error_code === 0) {
            _this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            _this.getGroups();
          }
        }).catch(function () {
          console.log('error');
        });
      }).catch(function () {});
    },

    handleAdd: function handleAdd() {
      this.editFormVisible = true;
      this.editFormTtile = '新增';
      this.editForm.id = 0;
      this.editForm.groupName = '';
      this.editForm.teacher = '';
      this.editForm.linkman = '';
      this.editForm.phone = '';
    },

    handleEdit: function handleEdit(row) {
      this.editFormVisible = true;
      this.editFormTtile = '编辑';
      this.editForm.id = row.id;
      this.editForm.groupName = row.groupName;
      this.editForm.teacher = row.teacher;
      this.editForm.linkman = row.linkman;
      this.editForm.phone = row.phone;
    },

    editSubmit: function editSubmit() {
      var _this = this;

      _this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this.editLoading = true;
            _this.btnEditText = '提交中';

            __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].updateGroup(_this.editForm).then(function (res) {
              if (res.error_code === 0) {
                _this.$notify({
                  title: '成功',
                  message: '提交成功',
                  type: 'success'
                });
                _this.editLoading = false;
                _this.btnEditText = '提 交';
                _this.resetForm('editForm');
                _this.editFormVisible = false;
                _this.getGroups();
              }
            });
          }).catch(function () {});
        }
      });
    },

    showCreditBox: function showCreditBox(row) {
      this.addCreditVisible = true;
      this.addCreditForm.groupId = row.id;
      this.addCreditForm.type = '';
      this.addCreditForm.score = '';
      this.addCreditForm.message = '';
      this.addCreditForm.loanId = '';
    },
    addCreditSubmit: function addCreditSubmit() {
      var _this3 = this;

      var _this = this;
      _this.$refs.addCreditForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this.addCreditLoading = true;
            _this.btnAddCreditText = '提交中';

            __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].addCredit(_this.addCreditForm).then(function (res) {
              if (res.error_code === 0) {
                _this.$notify({
                  title: '成功',
                  message: '添加成功',
                  type: 'success'
                });
                _this.addCreditLoading = false;
                _this.btnAddCreditText = '提 交';
                _this.resetForm('addCreditForm');
                _this.addCreditVisible = false;
                _this.getGroups();
              }
            });
          }).catch(function () {});
        }
      });
    },
    handleCreditList: function handleCreditList(row) {
      this.creditListVisible = true;
      this.creditListGroupId = row.id;
      this.getPageCreditList(1);
    },
    getPageCreditList: function getPageCreditList(val) {
      this.creditListPage = val;
      this.checkCreditList();
    },
    checkCreditList: function checkCreditList() {
      var _this4 = this;

      var para = {
        groupId: this.creditListGroupId,
        page: this.creditListPage,
        pageSize: this.creditListPageSize
      };

      this.creditListLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].getCreditListPage(para).then(function (res) {
        console.log(2222222);
        console.log(res.data);
        _this4.creditListTotal = res.data.total;
        _this4.creditList = res.data.creditList;
        _this4.creditListLoading = false;
      }).catch(function () {});
    },
    handleCreditDel: function handleCreditDel(row) {
      var _this = this;
      this.$confirm('确认删除该信用记录吗?', '提示', {
        type: 'warning'
      }).then(function () {
        _this.creditListLoading = true;
        var para = {
          id: row.id
        };

        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].delCredit(para).then(function (res) {
          _this.creditListLoading = false;
          if (res.error_code === 0) {
            _this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            _this.checkCreditList();
          }
        }).catch(function () {
          console.log('error');
        });
      }).catch(function () {});
    },
    creditListRowClass: function creditListRowClass(row, index) {
      if (row.type === 2) {
        return 'bad-credit';
      }

      return '';
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted: function mounted() {
    this.getPageGroups(1);
  }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_util__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__(51);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filters: {
        name: '',
        phone: '',
        group: ''
      },
      users: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      editFormVisible: false,
      editFormTtile: '编辑',
      editForm: {
        uid: 0,
        name: '',
        number: '',
        wxId: '',
        phone: '',
        email: '',
        group: '',
        role: '',
        authority: [],
        isAllAuthorityRange: true,
        devices: [] },
      editFormRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        number: [{ required: true, message: '请输入工号', trigger: 'blur' }],
        wxId: [{ required: true, message: '请输入微信ID', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        role: [{ required: true, type: 'number', message: '请选择用户角色', trigger: 'change' }],
        authority: [{ required: true, type: 'array', message: '请选择权限', trigger: 'change' }],
        group: [{ required: true, type: 'number', message: '请选择组别', trigger: 'change' }]
      },
      editLoading: false,
      btnEditText: '提 交',
      roleOptions: [{ label: '管理员', value: 1 }, { label: '借用人', value: 2 }],
      authorityOptions: [{ label: '系统管理权', value: 1 }, { label: '领导审核权', value: 2 }, { label: '管理员审核权', value: 3 }],
      deviceFilters: {
        deviceName: ''
      },
      devices: [],
      devicesTotal: 0,
      devicesPage: 1,
      devicesPageSize: 6,
      devicesListLoading: false,
      selectedDevicesTags: []
    };
  },

  computed: {
    groupOptions: function groupOptions() {
      return this.$store.state.base.groupOptions;
    },
    formattedUsers: function formattedUsers() {
      var _this2 = this;

      var formattedUsers = [];

      formattedUsers = this.users.map(function (item, index) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.roleOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var role = _step.value;

            if (role.value === item.role) {
              item.formattedRole = role.label;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        item.formattedAuthority = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(item.authority), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var authority = _step2.value;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.authorityOptions), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var authorityOption = _step4.value;

                if (authorityOption.value === authority) {
                  item.formattedAuthority.push(authorityOption.label);
                  break;
                }
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.groupOptions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var group = _step3.value;

            if (group.id === item.group) {
              item.formattedGroup = group.groupName;
              break;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return item;
      });

      return formattedUsers;
    },
    deviceAdministrators: function deviceAdministrators() {
      return this.$store.state.base.deviceAdministrators;
    },
    formattedDevices: function formattedDevices() {
      var _this3 = this;

      var formattedDevices = [];

      formattedDevices = this.devices.map(function (item, index) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.deviceAdministrators), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var administrator = _step5.value;

            if (administrator.uid === item.administrator) {
              item.formattedAdministrator = administrator.name;
              break;
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        return item;
      });

      return formattedDevices;
    },
    selectedDevicesId: function selectedDevicesId() {
      return this.selectedDevicesTags.map(function (item) {
        return item.id;
      });
    }
  },
  methods: {
    getPageUsers: function getPageUsers(val) {
      this.page = val;
      this.getUsers();
    },
    getUsers: function getUsers() {
      var _this4 = this;

      var checkedFilters = {};

      for (var item in this.filters) {
        if (this.filters.hasOwnProperty(item) && !!this.filters[item].toString()) {
          checkedFilters[item] = this.filters[item];
        }
      }

      var para = {
        page: this.page,
        pageSize: this.pageSize,
        filters: checkedFilters
      };

      this.listLoading = true;
      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].getUserListPage(para).then(function (res) {
        _this4.total = res.data.total;
        _this4.users = res.data.users;
        _this4.listLoading = false;
      }).catch(function () {});
    },

    handleDel: function handleDel(row) {
      var _this = this;
      this.$confirm('确认删除该用户吗?', '提示', {
        type: 'warning'
      }).then(function () {
        _this.listLoading = true;
        var para = {
          uid: row.uid
        };

        __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].delUser(para).then(function (res) {
          _this.listLoading = false;
          if (res.error_code === 0) {
            _this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            _this.getUsers();
          }
        }).catch(function () {
          console.log('error');
        });
      }).catch(function () {});
    },

    handleAdd: function handleAdd() {
      this.editFormVisible = true;
      this.editFormTtile = '新增';
      this.editForm.uid = 0;
      this.editForm.name = '';
      this.editForm.number = '';
      this.editForm.wxId = '';
      this.editForm.phone = '';
      this.editForm.email = '';
      this.editForm.role = '';
      this.editForm.authority = [];
      this.editForm.isAllAuthorityRange = true;
      this.editForm.group = '';
      this.editForm.devices = [];
      this.selectedDevicesTags = [];

      this.getPageDevices(1);
    },

    handleEdit: function handleEdit(row) {
      this.editFormVisible = true;
      this.editFormTtile = '编辑';
      this.editForm.uid = row.uid;
      this.editForm.name = row.name;
      this.editForm.number = row.number;
      this.editForm.wxId = row.wxId;
      this.editForm.phone = row.phone;
      this.editForm.email = row.email;
      this.editForm.role = row.role;
      this.editForm.authority = row.authority;
      this.editForm.isAllAuthorityRange = row.isAllAuthorityRange;
      this.editForm.group = row.group;


      this.getPageDevices(1);
    },

    editSubmit: function editSubmit() {
      var _this = this;

      _this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this.editLoading = true;
            _this.btnEditText = '提交中';
            _this.editForm.devices = _this.selectedDevicesId;

            console.log(_this.editForm);
            __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].updateUser(_this.editForm).then(function (res) {
              if (res.error_code === 0) {
                _this.$notify({
                  title: '成功',
                  message: '提交成功',
                  type: 'success'
                });
                _this.editLoading = false;
                _this.btnEditText = '提 交';
                _this.resetForm();
                _this.editFormVisible = false;
                _this.getUsers();
              }
            });
          }).catch(function () {});
        }
      });
    },
    getPageDevices: function getPageDevices(val) {
      this.devicesPage = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this5 = this;

      var para = {
        page: this.devicesPage,
        pageSize: this.devicesPageSize,
        filters: this.deviceFilters
      };

      this.devicesListLoading = true;
      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].getDeviceListPage(para).then(function (res) {
        _this5.devicesTotal = res.data.total;
        _this5.devices = res.data.devices;
        _this5.devicesListLoading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      var _this6 = this,
          _selectedDevicesTags;

      var checkedSelection = selection.filter(function (item) {
        var isSelected = false;

        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this6.selectedDevicesTags), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var selectedItem = _step6.value;

            if (item.id === selectedItem.id) {
              isSelected = true;
              break;
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        return !isSelected;
      });

      (_selectedDevicesTags = this.selectedDevicesTags).push.apply(_selectedDevicesTags, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(checkedSelection));
    },
    selectedDeviceClose: function selectedDeviceClose(tag) {
      this.selectedDevicesTags.splice(this.selectedDevicesTags.indexOf(tag), 1);
    },
    resetForm: function resetForm(formName) {
      this.$refs.editForm.resetFields();
    }
  },
  mounted: function mounted() {
    this.getUsers();
    this.getDevices();
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__ = __webpack_require__(62);



var baseUrl = '/ajaxhandler.ashx';
/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(req, cb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'login',
          data: req
        }
      }).then(function (res) {
        cb(res);
        resolve(res);
      }).catch(function (error) {
        console.warn(error);
      });
    });
  },
  getInitialInfo: function getInitialInfo(cb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'getInitialInfo'
        }
      }).then(function (res) {
        cb(res);
      }).catch(function (error) {
        console.warn(error);
      });
    });
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__ = __webpack_require__(62);



var baseUrl = '/ajaxhandler.ashx';
/* harmony default export */ __webpack_exports__["a"] = ({
  getDeviceListPage: function getDeviceListPage(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'getDeviceListPage',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.warn(error);
      });
    });
  },
  updateDevice: function updateDevice(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'updateDevice',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.log(error);
      });
    });
  },
  delDevice: function delDevice(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'delDevice',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.log(error);
      });
    });
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__ = __webpack_require__(62);



var baseUrl = '/ajaxhandler.ashx';
/* harmony default export */ __webpack_exports__["a"] = ({
  getGroupListPage: function getGroupListPage(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'getGroupListPage',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.warn(error);
      });
    });
  },
  updateGroup: function updateGroup(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'updateGroup',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.log(error);
      });
    });
  },
  delGroup: function delGroup(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'delGroup',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.log(error);
      });
    });
  },
  getCreditListPage: function getCreditListPage(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'getCreditListPage',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.warn(error);
      });
    });
  },
  addCredit: function addCredit(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'addCredit',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.log(error);
      });
    });
  },
  delCredit: function delCredit(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'delCredit',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.log(error);
      });
    });
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__ = __webpack_require__(62);



var baseUrl = '/ajaxhandler.ashx';
/* harmony default export */ __webpack_exports__["a"] = ({
  getLoanListPage: function getLoanListPage(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'getLoanListPage',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.warn(error);
      });
    });
  },
  handleAdminExamine: function handleAdminExamine(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'handleAdminExamine',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.warn(error);
      });
    });
  },
  handleLeaderExamine: function handleLeaderExamine(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'handleLeaderExamine',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.warn(error);
      });
    });
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__ = __webpack_require__(62);



var baseUrl = '/ajaxhandler.ashx';
/* harmony default export */ __webpack_exports__["a"] = ({
  getUserListPage: function getUserListPage(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'getUserListPage',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.warn(error);
      });
    });
  },
  updateUser: function updateUser(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'updateUser',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.log(error);
      });
    });
  },
  delUser: function delUser(req) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_ajax__["a" /* default */])({
        url: baseUrl,
        data: {
          mode: 'delUser',
          data: req
        }
      }).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        console.log(error);
      });
    });
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var creditItem = {
  id: 1234,
  type: 2,
  score: 5,
  message: '按时完好归还',
  loanId: 123456
};

var CreditList = [];

for (var i = 0; i < 15; i++) {
  CreditList.push(creditItem);
}

/* harmony default export */ __webpack_exports__["a"] = (function (req) {
  var page = req.page,
      pageSize = req.pageSize;


  var total = CreditList.length;

  var resCreditList = CreditList.filter(function (u, index) {
    return index < pageSize * page && index >= pageSize * (page - 1);
  });

  return { error_code: 0, msg: '请求成功', data: {
      total: total,
      creditList: resCreditList
    } };
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mockdata_devices__ = __webpack_require__(265);


/* harmony default export */ __webpack_exports__["a"] = (function (req) {
  var page = req.page,
      pageSize = req.pageSize;


  var total = __WEBPACK_IMPORTED_MODULE_0__mockdata_devices__["a" /* Devices */].length;

  var resDevices = __WEBPACK_IMPORTED_MODULE_0__mockdata_devices__["a" /* Devices */].filter(function (u, index) {
    return index < pageSize * page && index >= pageSize * (page - 1);
  });

  return { error_code: 0, msg: '请求成功', data: {
      total: total,
      devices: resDevices
    } };
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mockdata_groups__ = __webpack_require__(266);


/* harmony default export */ __webpack_exports__["a"] = (function (req) {
  var page = req.page,
      pageSize = req.pageSize;


  var total = __WEBPACK_IMPORTED_MODULE_0__mockdata_groups__["a" /* Groups */].length;

  var resGroups = __WEBPACK_IMPORTED_MODULE_0__mockdata_groups__["a" /* Groups */].filter(function (u, index) {
    return index < pageSize * page && index >= pageSize * (page - 1);
  });

  return { error_code: 0, msg: '请求成功', data: {
      total: total,
      groups: resGroups
    } };
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var groupOptions = [{
    groupName: '组别1',
    id: 1
  }, {
    groupName: '组别2',
    id: 2
  }, {
    groupName: '组别3',
    id: 3
  }];

  var deviceAdministrators = [{
    name: '设备管理员1',
    uid: 111
  }, {
    name: '设备管理员2',
    uid: 222
  }, {
    name: '设备管理员3',
    uid: 333
  }];

  var initialPassword = '12345678';

  return { error_code: 0, msg: '请求成功', data: {
      groupOptions: groupOptions,
      deviceAdministrators: deviceAdministrators,
      initialPassword: initialPassword
    } };
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mockdata_loans__ = __webpack_require__(267);


/* harmony default export */ __webpack_exports__["a"] = (function (req) {
  var page = req.page,
      pageSize = req.pageSize;


  var total = __WEBPACK_IMPORTED_MODULE_0__mockdata_loans__["a" /* Loans */].length;

  var resLoans = __WEBPACK_IMPORTED_MODULE_0__mockdata_loans__["a" /* Loans */].filter(function (u, index) {
    return index < pageSize * page && index >= pageSize * (page - 1);
  });

  return { error_code: 0, msg: '请求成功', data: {
      total: total,
      loanList: resLoans
    } };
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mockdata_user__ = __webpack_require__(268);


/* harmony default export */ __webpack_exports__["a"] = (function (req) {
  var page = req.page,
      pageSize = req.pageSize;


  var total = __WEBPACK_IMPORTED_MODULE_0__mockdata_user__["a" /* Users */].length;

  var resUsers = __WEBPACK_IMPORTED_MODULE_0__mockdata_user__["a" /* Users */].filter(function (u, index) {
    return index < pageSize * page && index >= pageSize * (page - 1);
  });

  return { error_code: 0, msg: '请求成功', data: {
      total: total,
      users: resUsers
    } };
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

var LoginUsers = [{
  uid: 1,
  username: 'admin',
  password: '123456',
  role: 1,
  authority: [1]
}, {
  uid: 2,
  username: 'admin2',
  password: '123456',
  role: 1,
  authority: [2]
}, {
  uid: 3,
  username: 'admin3',
  password: '123456',
  role: 1,
  authority: [3]
}];

/* harmony default export */ __webpack_exports__["a"] = (function (data) {
  var isRegister = false;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(LoginUsers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var user = _step.value;

      if (user.username === data.username) {
        isRegister = true;
        if (user.password === data.password) {
          var uid = user.uid,
              username = user.username,
              role = user.role,
              authority = user.authority;

          return { error_code: 0, msg: '登录成功', data: { uid: uid, username: username, role: role, authority: authority } };
        } else {
          return { error_code: -1, msg: '用户名和密码不正确' };
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (!isRegister) {
    return { error_code: -2, msg: '该用户不存在' };
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mockjs__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Devices; });


var Devices = [];

for (var i = 0; i < 35; i++) {
  Devices.push(__WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
    id: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      'id': /\d{5}/
    }).id * 1,
    deviceName: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.ctitle(5),
    administrator: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      "admin|1": [111, 222, 333]
    }).admin,
    location: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.city(),
    price: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      "number|1-100": 100
    }).number,
    status: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      "status|1": [1, 2, 3, 4, 5]
    }).status
  }));
}



/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mockjs__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Groups; });


var Groups = [];

for (var i = 0; i < 25; i++) {
  Groups.push(__WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
    id: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      'wxId': /\d{5}/
    }).wxId * 1,
    groupName: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.ctitle(5),
    teacher: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.cname(),
    linkman: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.cname(),
    phone: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      'regexp': /13\d{9}/
    }).regexp,
    creditScore: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      "score|1-100": 100
    }).score
  }));
}



/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mockjs__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loans; });


var Loans = [];

for (var i = 0; i < 55; i++) {
  Loans.push(__WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
    loanId: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      'wxId': /\d{5}/
    }).wxId * 1,
    device: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.ctitle(5),
    status: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      "status|1": [1, 2, 3, 4, 5, 6, 7, 8, 9]
    }).status,
    loaner: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.cname(),
    phone: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      'regexp': /13\d{9}/
    }).regexp,
    email: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.email(),
    loanTime: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      loanTime: new Date(new Date().getTime() - Math.floor(Math.random() * 300000000)).getTime()
    }).loanTime,
    returnTime: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      returnTime: new Date(new Date().getTime() + Math.floor(Math.random() * 300000000)).getTime()
    }).returnTime,
    realReturnTime: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      realReturnTime: new Date(new Date().getTime() + Math.floor(Math.random() * 200000000)).getTime()
    }).realReturnTime
  }));
}



/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mockjs__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Users; });


var Users = [];

for (var i = 0; i < 50; i++) {
  Users.push(__WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
    uid: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      'wxId': /\d{5}/
    }).wxId * 1,
    wxId: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      'wxId': /\d{8}/
    }).wxId,
    number: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      'number': /3113\d{6}/
    }).number,
    name: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.cname(),

    phone: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      'regexp': /13\d{9}/
    }).regexp,
    email: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random.email(),
    authority: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      authorityArr: [1, 2, 3],
      authority: function authority() {
        return this.authorityArr.filter(function () {
          return Math.random() > 0.5;
        });
      }
    }).authority,
    isAllAuthorityRange: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      "boolean|1": true
    }).boolean,
    role: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      "role|1": [1, 2]
    }).role,
    group: __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
      "group|1": [1, 2, 3]
    }).group
  }));
}



/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(144);




var state = {
  initialPassword: '',
  groupOptions: [],
  deviceAdministrators: []
};

var actions = {
  getInitialInfo: function getInitialInfo(_ref) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].getInitialInfo(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_INITIAL */], res);
    });
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_INITIAL */], function (state, res) {
  if (res.error_code === 0) {
    state.initialPassword = res.data.initialPassword;
    state.groupOptions = res.data.groupOptions;
    state.deviceAdministrators = res.data.deviceAdministrators;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(144);



var _mutations;




var state = {
  isLogin: false,
  userData: {
    uid: '',
    username: '',
    role: '',
    authority: '',
    token: ''
  }
};

var actions = {
  login: function login(_ref, payload) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].login(payload.data, function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* LOGIN_IN */], res);
    });
  },
  signOut: function signOut(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* EXIT_LOGIN */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* LOGIN_IN */], function (state, res) {
  state.isLogin = res.error_code === 0;
  state.userData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.userData, res.data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* EXIT_LOGIN */], function (state) {
  state.isLogin = false;
  state.userData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.userData, {
    uid: '',
    username: '',
    role: '',
    authority: '',
    token: ''
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__group__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loan__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__device__ = __webpack_require__(254);







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_1__base__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__group__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__loan__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__device__["a" /* default */]));

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(35)(
  /* script */
  null,
  /* template */
  __webpack_require__(531),
  /* scopeId */
  "data-v-3d5f3c24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  "data-v-161a1b7a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  "data-v-715f8696",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  "data-v-116d061d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  "data-v-7fd5fa9b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  "data-v-2717371b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  "data-v-1f591d7f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  "data-v-4ec0d7fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 526:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "panel"
  }, [_c('el-col', {
    staticClass: "panel-top",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticStyle: {
      "font-size": "26px"
    },
    attrs: {
      "span": 20
    }
  }, [_c('i', {
    staticClass: "logo iconfont icon-computer"
  }), _vm._v("\n\t\t\t\t大型仪器外借管理系统\n\t\t\t")]), _vm._v(" "), _c('el-col', {
    staticClass: "rightbar",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link",
    staticStyle: {
      "color": "#c0ccda",
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("我的消息")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("设置")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "panel-center",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    staticStyle: {
      "width": "180px"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "theme": "dark",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child, index) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: index,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "panel-c-c"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticStyle: {
      "width": "200px",
      "float": "left",
      "color": "#475669"
    }
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "background-color": "#fff",
      "box-sizing": "border-box"
    },
    attrs: {
      "span": 24
    }
  }, [_c('router-view')], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "团队"
    },
    model: {
      value: (_vm.filters.groupName),
      callback: function($$v) {
        _vm.filters.groupName = $$v
      },
      expression: "filters.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "导师"
    },
    model: {
      value: (_vm.filters.teacher),
      callback: function($$v) {
        _vm.filters.teacher = $$v
      },
      expression: "filters.teacher"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getPageGroups(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.groups,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": "团队名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "teacher",
      "label": "导师"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "linkman",
      "label": "联系人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "联系方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creditScore",
      "label": "信用积分",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "信用记录",
      "width": "150"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.showCreditBox(scope.row)
            }
          }
        }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleCreditList(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "350"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.checkUsers(scope.row)
            }
          }
        }, [_vm._v("查看成员")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.checkLoans(scope.row)
            }
          }
        }, [_vm._v("查看借用记录")])]
      }]
    ])
  })], 1)], _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.getPageGroups
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTtile
    },
    on: {
      "close": function($event) {
        _vm.resetForm('editForm')
      }
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团队名",
      "prop": "groupName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.groupName),
      callback: function($$v) {
        _vm.editForm.groupName = $$v
      },
      expression: "editForm.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "导师",
      "prop": "teacher"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.teacher),
      callback: function($$v) {
        _vm.editForm.teacher = $$v
      },
      expression: "editForm.teacher"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "linkman"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.linkman),
      callback: function($$v) {
        _vm.editForm.linkman = $$v
      },
      expression: "editForm.linkman"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.phone),
      callback: function($$v) {
        _vm.editForm.phone = $$v
      },
      expression: "editForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnEditText))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加信用记录"
    },
    on: {
      "close": function($event) {
        _vm.resetForm('addCreditForm')
      }
    },
    model: {
      value: (_vm.addCreditVisible),
      callback: function($$v) {
        _vm.addCreditVisible = $$v
      },
      expression: "addCreditVisible"
    }
  }, [_c('el-form', {
    ref: "addCreditForm",
    attrs: {
      "model": _vm.addCreditForm,
      "label-width": "100px",
      "rules": _vm.addCreditFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加分/减分",
      "prop": "type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addCreditForm.type),
      callback: function($$v) {
        _vm.addCreditForm.type = $$v
      },
      expression: "addCreditForm.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("加分")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("减分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分数",
      "prop": "score"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 20
    },
    model: {
      value: (_vm.addCreditForm.score),
      callback: function($$v) {
        _vm.addCreditForm.score = $$v
      },
      expression: "addCreditForm.score"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.addCreditForm.message),
      callback: function($$v) {
        _vm.addCreditForm.message = $$v
      },
      expression: "addCreditForm.message"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "借用记录编号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addCreditForm.loanId),
      callback: function($$v) {
        _vm.addCreditForm.loanId = $$v
      },
      expression: "addCreditForm.loanId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addCreditVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addCreditLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.addCreditSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnAddCreditText) + "\n      ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "信用记录"
    },
    model: {
      value: (_vm.creditListVisible),
      callback: function($$v) {
        _vm.creditListVisible = $$v
      },
      expression: "creditListVisible"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.creditListLoading),
      expression: "creditListLoading"
    }],
    attrs: {
      "data": _vm.formattedCreditList,
      "row-class-name": _vm.creditListRowClass
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-form', {
          staticClass: "credit-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "说明"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.message))])])], 1)]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedType",
      "label": "加分/减分"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "score",
      "label": "分数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loanId",
      "label": "借用记录编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleCreditDel(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.creditListPage,
      "page-size": _vm.creditListPageSize,
      "total": _vm.creditListTotal
    },
    on: {
      "current-change": _vm.getPageCreditList
    }
  })], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "借用编号"
    },
    model: {
      value: (_vm.filters.loanId),
      callback: function($$v) {
        _vm.filters.loanId = $$v
      },
      expression: "filters.loanId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "借用设备"
    },
    model: {
      value: (_vm.filters.device),
      callback: function($$v) {
        _vm.filters.device = $$v
      },
      expression: "filters.device"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "借用人"
    },
    model: {
      value: (_vm.filters.loaner),
      callback: function($$v) {
        _vm.filters.loaner = $$v
      },
      expression: "filters.loaner"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "联系方式"
    },
    model: {
      value: (_vm.filters.phone),
      callback: function($$v) {
        _vm.filters.phone = $$v
      },
      expression: "filters.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择组别"
    },
    model: {
      value: (_vm.filters.group),
      callback: function($$v) {
        _vm.filters.group = $$v
      },
      expression: "filters.group"
    }
  }, _vm._l((_vm.groupOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.groupName,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "398px"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.filters.status = $$v
      },
      expression: "filters.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getPageLoans(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formattedLoanList,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-form', {
          staticClass: "loan-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "借用编号"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.loanId))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "借用设备"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.device))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "状态"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedStatus))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "借用人"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.loaner))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "联系方式"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.phone))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "邮箱"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.email))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "借用时间"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedLoanTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "应归还时间"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedReturnTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "实际归还时间"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedRealReturnTime))])])], 1)]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loanId",
      "label": "借用编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device",
      "label": "借用设备"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loaner",
      "label": "借用人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedLoanTime",
      "label": "借用时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedReturnTime",
      "label": "应归还时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedStatus",
      "label": "状态",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "350"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [(_vm.$store.state.user.userData.authority.indexOf(1) > -1 ||
          _vm.$store.state.user.userData.authority.indexOf(3) > -1) ? [(scope.row.status === 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.handleAdminExamine(scope.row, true)
            }
          }
        }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleAdminExamine(scope.row, false)
            }
          }
        }, [_vm._v("不通过")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.$store.state.user.userData.authority.indexOf(2) > -1) ? [(scope.row.status === 2) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.handleLeaderExamine(scope.row, true)
            }
          }
        }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleLeaderExamine(scope.row, false)
            }
          }
        }, [_vm._v("不通过")]) : _vm._e()] : _vm._e(), _vm._v(" "), (scope.row.status > 2) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.showCreditBox(scope.row)
            }
          }
        }, [_vm._v("添加信用记录")]) : _vm._e()]
      }]
    ])
  })], 1)], _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.getPageLoans
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加信用记录"
    },
    on: {
      "close": function($event) {
        _vm.resetForm('addCreditForm')
      }
    },
    model: {
      value: (_vm.addCreditVisible),
      callback: function($$v) {
        _vm.addCreditVisible = $$v
      },
      expression: "addCreditVisible"
    }
  }, [_c('el-form', {
    ref: "addCreditForm",
    attrs: {
      "model": _vm.addCreditForm,
      "label-width": "110px",
      "rules": _vm.addCreditFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加分/减分",
      "prop": "type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addCreditForm.type),
      callback: function($$v) {
        _vm.addCreditForm.type = $$v
      },
      expression: "addCreditForm.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("加分")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("减分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分数",
      "prop": "score"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 20
    },
    model: {
      value: (_vm.addCreditForm.score),
      callback: function($$v) {
        _vm.addCreditForm.score = $$v
      },
      expression: "addCreditForm.score"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.addCreditForm.message),
      callback: function($$v) {
        _vm.addCreditForm.message = $$v
      },
      expression: "addCreditForm.message"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "借用记录编号",
      "prop": "loanId"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.addCreditForm.loanId),
      callback: function($$v) {
        _vm.addCreditForm.loanId = _vm._n($$v)
      },
      expression: "addCreditForm.loanId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addCreditVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addCreditLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.addCreditSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnAddCreditText) + "\n      ")])], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notFound-wrapper"
  }, [_c('p', {
    staticClass: "not-found"
  }, [_vm._v("404")]), _vm._v(" "), _c('p', {
    staticClass: "not-found-text"
  }, [_vm._v("该页面不存在")])])
}]}

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.filters.name = $$v
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "联系方式"
    },
    model: {
      value: (_vm.filters.phone),
      callback: function($$v) {
        _vm.filters.phone = $$v
      },
      expression: "filters.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择组别"
    },
    model: {
      value: (_vm.filters.group),
      callback: function($$v) {
        _vm.filters.group = $$v
      },
      expression: "filters.group"
    }
  }, _vm._l((_vm.groupOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.groupName,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getPageUsers(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formattedUsers,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-form', {
          staticClass: "user-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.name))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "工号"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.number))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "微信ID"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.wxId))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "联系方式"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.phone))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "邮箱"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.email))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "角色"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedRole))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "权限"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedAuthority.join('，')))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "组别"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedGroup))])])], 1)]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedRole",
      "label": "角色"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedAuthority",
      "label": "权限"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.formattedAuthority.join('，')))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedGroup",
      "label": "组别"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }]
    ])
  })], 1)], _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.getPageUsers
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTtile
    },
    on: {
      "close": _vm.resetForm
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.editForm.name = $$v
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工号",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.number),
      callback: function($$v) {
        _vm.editForm.number = $$v
      },
      expression: "editForm.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信ID",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.wxId),
      callback: function($$v) {
        _vm.editForm.wxId = $$v
      },
      expression: "editForm.wxId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.phone),
      callback: function($$v) {
        _vm.editForm.phone = $$v
      },
      expression: "editForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.email),
      callback: function($$v) {
        _vm.editForm.email = $$v
      },
      expression: "editForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组别",
      "prop": "group"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择组别"
    },
    model: {
      value: (_vm.editForm.group),
      callback: function($$v) {
        _vm.editForm.group = _vm._n($$v)
      },
      expression: "editForm.group"
    }
  }, _vm._l((_vm.groupOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.groupName,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.role),
      callback: function($$v) {
        _vm.editForm.role = _vm._n($$v)
      },
      expression: "editForm.role"
    }
  }, _vm._l((_vm.roleOptions), function(item) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n          ")])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.role === 1),
      expression: "editForm.role === 1"
    }],
    attrs: {
      "label": "权限",
      "prop": "authority"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.editForm.authority),
      callback: function($$v) {
        _vm.editForm.authority = $$v
      },
      expression: "editForm.authority"
    }
  }, _vm._l((_vm.authorityOptions), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n          ")])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.role === 1),
      expression: "editForm.role === 1"
    }],
    attrs: {
      "label": "全局权限"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    model: {
      value: (_vm.editForm.isAllAuthorityRange),
      callback: function($$v) {
        _vm.editForm.isAllAuthorityRange = $$v
      },
      expression: "editForm.isAllAuthorityRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.role === 1 && _vm.editForm.isAllAuthorityRange === false),
      expression: "editForm.role === 1 && editForm.isAllAuthorityRange === false"
    }],
    attrs: {
      "label": "选择设备"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.selectedDevicesTags), function(tag) {
    return _c('el-tag', {
      key: tag.id,
      attrs: {
        "closable": true,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          _vm.selectedDeviceClose(tag)
        }
      }
    }, [_vm._v(_vm._s(tag.deviceName))])
  })), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.deviceFilters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "设备名",
      "size": "small"
    },
    model: {
      value: (_vm.deviceFilters.deviceName),
      callback: function($$v) {
        _vm.deviceFilters.deviceName = $$v
      },
      expression: "deviceFilters.deviceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.getPageDevices(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formattedDevices
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "设备编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceName",
      "label": "设备名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedAdministrator",
      "label": "设备管理员"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "current-page": _vm.devicesPage,
      "page-size": _vm.devicesPageSize,
      "total": _vm.devicesTotal
    },
    on: {
      "current-change": _vm.getPageDevices
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnEditText))])], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm card-box loginform",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("大型仪器外借管理系统")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.ruleForm2.account = $$v
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.ruleForm2.checkPass = $$v
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin": "0px 0px 35px 0px"
    },
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "设备编号"
    },
    model: {
      value: (_vm.filters.id),
      callback: function($$v) {
        _vm.filters.id = _vm._n($$v)
      },
      expression: "filters.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "设备名"
    },
    model: {
      value: (_vm.filters.deviceName),
      callback: function($$v) {
        _vm.filters.deviceName = $$v
      },
      expression: "filters.deviceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择设备状态"
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.filters.status = $$v
      },
      expression: "filters.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择设备管理员"
    },
    model: {
      value: (_vm.filters.administrator),
      callback: function($$v) {
        _vm.filters.administrator = $$v
      },
      expression: "filters.administrator"
    }
  }, _vm._l((_vm.deviceAdministrators), function(item) {
    return _c('el-option', {
      key: item.uid,
      attrs: {
        "label": item.name,
        "value": item.uid
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getPageDevices(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formattedDevices,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "设备编号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceName",
      "label": "设备名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedAdministrator",
      "label": "设备管理员"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "location",
      "label": "存放地"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedStatus",
      "label": "状态",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.checkLoans(scope.row)
            }
          }
        }, [_vm._v("查看借用记录")])]
      }]
    ])
  })], 1)], _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.getPageDevices
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTtile
    },
    on: {
      "close": function($event) {
        _vm.resetForm('editForm')
      }
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备名",
      "prop": "deviceName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.deviceName),
      callback: function($$v) {
        _vm.editForm.deviceName = $$v
      },
      expression: "editForm.deviceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备管理员",
      "prop": "administrator"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择设备管理员"
    },
    model: {
      value: (_vm.editForm.administrator),
      callback: function($$v) {
        _vm.editForm.administrator = $$v
      },
      expression: "editForm.administrator"
    }
  }, _vm._l((_vm.deviceAdministrators), function(item) {
    return _c('el-option', {
      key: item.uid,
      attrs: {
        "label": item.name,
        "value": item.uid
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "存放地",
      "prop": "location"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.location),
      callback: function($$v) {
        _vm.editForm.location = $$v
      },
      expression: "editForm.location"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.editForm.price),
      callback: function($$v) {
        _vm.editForm.price = $$v
      },
      expression: "editForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.editForm.status),
      callback: function($$v) {
        _vm.editForm.status = $$v
      },
      expression: "editForm.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnEditText))])], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

function ajax(_ref) {
  var method = _ref.method,
      url = _ref.url,
      data = _ref.data,
      successMsg = _ref.successMsg;

  method = method || 'post';

  if (!url) {
    __WEBPACK_IMPORTED_MODULE_1__main__["default"].$notify({
      title: '警告',
      message: '请求被驳回，请传入请求url！',
      type: 'warning',
      duration: 3000
    });

    return;
  }

  var args = {
    method: method,
    url: url
  };

  method = method.toLowerCase();
  if (method === 'post') {
    args.data = data;
  } else if (method === 'get') {
    args.params = data;
  } else {
    args.data = data;
  }

  return __WEBPACK_IMPORTED_MODULE_2_axios___default()(args).then(function (response) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (response.data.error_code === 0) {
        if (!!successMsg) {
          __WEBPACK_IMPORTED_MODULE_1__main__["default"].$notify({
            title: '成功',
            message: successMsg,
            type: 'success',
            duration: 3000
          });
        }
        resolve(response.data);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__main__["default"].$notify({
          title: '错误',
          message: response.data.msg,
          type: 'error',
          duration: 3000
        });
        reject(response.data);
      }
    });
  }, function (response) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__main__["default"].$notify({
        title: '失败',
        message: response.message,
        type: 'error',
        duration: 4000
      });
      reject(response);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (ajax);

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {
        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

});

/***/ })

},[143]);


// WEBPACK FOOTER //
// static/js/app.d0568d0ca304e4706280.js